  <div class="statistic-leaders" *ngIf="statistic.length > 0">
    <div class="row" *ngFor="let param of playersParams">
      <div class="leader-title">{{ param.title }}</div>
      <mtg-statistic-leaders
        [statistic]="statistic"
        [param]="param"
        [seasonId]="seasonId"
      ></mtg-statistic-leaders>
    </div>
  </div>
